<template>
  <div id="app">
    <main-header></main-header>
    <transition :name="`el-fade-in`">
      <router-view class="main-content" />
    </transition>
    <main-footer></main-footer>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex"

import MainHeader from "./components/Layout/MainHeader"
import MainFooter from "./components/Layout/MainFooter"

const { mapState, mapMutations } = createNamespacedHelpers("app")

export default {
  components: {
    MainHeader,
    MainFooter
  },
  metaInfo() {
    return {
      title: this.$t("SHARED__APP_TITLE"),
      htmlAttrs: {
        lang: this.$i18n.locale
      },
      meta: [
        {
          name: "description",
          content: this.$t("SHARED__APP_DESCRIPTION"),
          vmid: "description"
        },
        {
          name: "og:title",
          content: this.$t("SHARED__APP_TITLE"),
          vmid: "ogTitle"
        },
        {
          name: "og:image",
          content:
            this.$i18n.locale === "fr"
              ? "https://contest2018.s3.us-east-1.amazonaws.com/contest_fb_fr.jpg"
              : "https://contest2018.s3.us-east-1.amazonaws.com/contest_fb_fr.jpg",
          vmid: "ogImage"
        },
        {
          name: "og:description",
          content: this.$t("SHARED__APP_DESCRIPTION"),
          vmid: "ogDescription"
        },
        {
          name: "og:url",
          content:
            this.$i18n.locale === "fr"
              ? "https://voyagedereve.tuango.ca"
              : "https://fillyourplane.tuango.ca",
          vmid: "ogUrl"
        }
      ]
    }
  },
  data() {
    return {
      end: process.env.VUE_APP_CONTEST_END_DATE,
      now: +new Date()
    }
  },
  computed: {
    ...mapState(["isContestClosed", "lang", "appDomain"]),
    ogImage() {
      return this.$i18n.locale === "fr"
        ? "https://s3.amazonaws.com/contest2018/contest_fb_fr.jpg"
        : "https://s3.amazonaws.com/contest2018/contest_fb_en.jpg"
    }
  },
  watch: {
    $route(to, from) {
      this.transitionName = to.meta.page > from.meta.page ? "next" : "prev"
    },
    lang: {
      handler(val) {
        this.$i18n.locale = val
        this.$http.defaults.headers.common["Accept-Language"] = val
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations(["setLang"])
  },
  created() {
    if (this.appDomain === process.env.VUE_APP_DOMAIN_EN) {
      this.setLang("en")
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.name !== "rules" && from.name !== "error") {
      if (this.isContestClosed) {
        to.name = "contest-closed"
      }
    }
    next()
  }
}
</script>

<style lang="scss">
/* Transitions */

.next-leave-to {
  animation: leaveToLeft 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 0;
}

.next-enter-to {
  animation: enterFromRight 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 1;
}

.prev-leave-to {
  animation: leaveToRight 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 1;
}

.prev-enter-to {
  animation: enterFromLeft 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 0;
}

@keyframes leaveToLeft {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-25%);
    filter: brightness(0.5);
  }
}

@keyframes enterFromLeft {
  from {
    transform: translateX(-25%);
    filter: brightness(0.5);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes leaveToRight {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
}

@keyframes enterFromRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
</style>
